import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { BackendResponse, DateService, HttpService, TranslateService } from 'vas-mobile-api';

import { Transaction } from '../models/transaction';
import { DataExchangeService } from '../services/dataexchange.service';

@Component({
  selector: 'app-transactions-list',
  templateUrl: './transactions-list.component.html',
  styleUrls: ['./transactions-list.component.css']
})
export class TransactionsListComponent implements OnInit, OnDestroy, AfterViewInit {

  public locale: string;
  public currentTab: string;
  public showLoading = false;
  public isNaN = isNaN;
  public totalCurrent = NaN; // sum of current tab, calculated when switching to a tab.
  public totalSum = NaN; // total sum over all tabs, calculated manually or when all tabs have been visited
  public dataSource: MatTableDataSource<Transaction> = new MatTableDataSource<Transaction>();
  public displayColumns: string[] = ['TRANSACTION_TYPE', 'TRANSACTION_DATE', 'TOTAL_PRICE'];
  private columns: string[] = ['TRANSACTION_TYPE', 'TRANSACTION_DATE', 'TRANSACTION_TIME', 'TOTAL_PRICE', 'TRANSACTION_ID', 'BALANCE_ID'];
  public transactionTypes: any = {
    OUTG: 'LBLPANEL_VERSAND',
    INCO: 'LBLPANEL_INCOMING',
    RESE: 'LBLPANEL_RESERVATION',
    DELR: 'LABEL_COUNTER_RESERVATION',
    DELO: 'LABEL_COUNTER_SHIPMENT',
    DEBI: 'LABEL_MANUAL_TRANSFER',
    CRED: 'LABEL_MANUAL_TRANSFER',
    PAID: 'LBLPANEL_PAYMENT',
    RETR: 'LABEL_RETURN_RESERVATION',
    RETO: 'LBLPANEL_RETURNDELIVERY'
  };
  private ngUnsubscribe = new Subject<void>();
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  constructor(
    private httpService: HttpService,
    private des: DataExchangeService,
    private dateService: DateService,
    private router: Router,
    private dialog: MatDialog,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.locale = this.translateService.getLanguage();
    this.des.changeTitelBarName('TECHNICAL_REPLICATION_TRANSACTIONS');

    this.getTransactions();
    this.getSum();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private getTransactions() {
    this.showLoading = true;
    this.dataSource.data = [];
    this.httpService.get<BackendResponse<Transaction[]>>({
      pathId: 'getTransactionsByBalanceIdYCC', urlParams:
      {
        fields: this.columns,
        orderBy: ['TRANSACTION_DATE DESC', 'TRANSACTION_TIME DESC']
      }, customTimeout: 30000
    }).subscribe((response) => {
      response.data.forEach((t) => t.TRANSACTION_DATE = this.dateService.combineDateAndTime(t.TRANSACTION_DATE, t.TRANSACTION_TIME));
      this.dataSource.data = response.data;
      this.showLoading = false;
    }, (e) => {
      this.showLoading = false;
    });
  }

  public isIncoming(type: string) {
    return ['INCO', 'DELR', 'DELO', 'CRED', 'RETR', 'RETO'].findIndex(s => s === type) > -1;
  }

  public viewDetails(transaction: Transaction) {
    this.router.navigate(['transactionDetail', transaction.TRANSACTION_ID, transaction.BALANCE_ID]);
  }

  private getSum() {
   this.showLoading = true;
    this.httpService.get<BackendResponse<number>>({
      pathId: 'getBalanceSumYCC', customTimeout: 40000
    }).subscribe((response) => {
      this.totalCurrent = response.data;
      this.showLoading = false;
    }, (e) => {
      this.showLoading = false;
    });
  }

}